<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <div class="modal-title" i18n>Connect To Trip.com</div>
    <app-page-help articleId="d5gcrb5poh" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<mat-stepper [linear]="true" #stepper class="m-3">
  <mat-step
    i18n-label
    label="Getting Started"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 0 ? 'done' : 'number'"
  >
    <app-connect-trip-wizard-step1 (next)="stepper.next()"></app-connect-trip-wizard-step1>
  </mat-step>
  <mat-step
    i18n-label
    label="Preparation"
    [optional]="true"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
  >
    <app-connect-trip-wizard-step2
      (prev)="stepper.previous()"
      (next)="stepper.next()"
      #step2
    ></app-connect-trip-wizard-step2>
  </mat-step>
  <mat-step
    i18n-label
    label="Request Channel Manager Access"
    [optional]="true"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 2 ? 'done' : 'number'"
  >
    <app-connect-trip-wizard-step3
      (prev)="stepper.previous()"
      [channel]="channel"
      (connected)="stepper.next()"
      #step3
    ></app-connect-trip-wizard-step3>
  </mat-step>
  <mat-step
    i18n-label
    label="Complete"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 3 ? 'done' : 'number'"
  >
    <app-connect-trip-wizard-complete
      (reset)="stepper.reset(); step2.reset(); step3.reset()"
      (channel)="onChannel()"
      (done)="close()"
    ></app-connect-trip-wizard-complete>
  </mat-step>
  <ng-template matStepperIcon="done">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
</mat-stepper>
